// extracted by mini-css-extract-plugin
module.exports = {"o1nz8vq1":"o1nz8vq1","s12wa3g0":"s12wa3g0","s1u6jllm":"s1u6jllm","s1j7d6km":"s1j7d6km","s1pqhd22":"s1pqhd22"};